import RestService from '@/modules/backend/RestService';
import { Building } from '../Entities/Building';
import { plainToClass } from 'class-transformer';
import { CreateBuildingData } from '@/modules/backend/Dto/CreateBuildingData';
import { QueryBuildingsData } from '@/modules/backend/Dto/QueryBuildingsData';

export default class Buildings {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async Create(payload: CreateBuildingData): Promise<Building> {
    const result = await this.rest.post('/api/v1/building', payload);
    return plainToClass(Building, result);
  }

  public async List(companyId: number): Promise<Building[]> {
    const buildings = await this.rest.get<Building[]>(`/api/v1/company/${companyId}/buildings`);
    return plainToClass(Building, buildings);
  }

  public async Remove(buildingId: number): Promise<void> {
    await this.rest.delete(`/api/v1/building/${buildingId}`);
  }

  public async GetOne(buildingId: number): Promise<Building> {
    const building = await this.rest.get<Building>(`/api/v1/building/${buildingId}`);
    return plainToClass(Building, building);
  }

  public async fetch(query: QueryBuildingsData): Promise<Building[]> {
    try {
      return await this.rest.get<Building[]>('/api/v1/buildings', {
        params: {
          companies: query.companies?.length ? query.companies.join(',') : undefined,
          providers: query.providers?.length ? query.providers.join(',') : undefined,
          page: query.page
        }
      }, Building);
    } catch {
      return [];
    }
  }
}
